import { Http } from '@/lib/http';
export class CollateralTypesService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/collateral-types/';
  }
  createCollateralType(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }
  getCollateralTypes() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  updateCollateralType(id, payload) {
    return this.httpClient().patch(`${this.endpoint}${id}`, payload);
  }
  deleteCollateralType(id) {
    return this.httpClient().delete(`${this.endpoint}${id}`);
  }
}
